<template>
  <div class="app-container">
    <el-select v-model="listQuery.type" :placeholder="'Source'" style="width: 90px" class="filter-item" @change="handleFilter">
      <el-option v-for="item in typeOpitons" :key="item.value" :label="item.label" :value="item.value" />
    </el-select>
    <span> - {{ userSelf.name }}({{ userSelf.number }}) - Balance: {{ userSelf.credits }}</span>
    <el-table v-loading="listLoading" :data="list" fit highlight-current-row>
      <el-table-column align="center" label="Date & Time" style="width: 30%">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Actions" style="width: 20%">
        <template slot-scope="scope">
          <span>{{ scope.row.typeName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Type" style="width: 20%">
        <template slot-scope="scope">
          <span>{{ scope.row.statusName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Change" style="width: 20%">
        <template slot-scope="scope">
          <span>{{ scope.row.credits }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import EventResource from '@/api/event'
const eventResource = new EventResource()
export default {
  name: 'StudentList',
  components: { Pagination },
  data() {
    return {
      list: null,
      total: 0,
      userSelf: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        type: 'all'
      },
      typeOpitons: [
        { 'value': 'all', 'label': '全部' },
        { 'value': 'purchase', 'label': '儲值' },
        { 'value': 'lesson', 'label': '課堂' },
        { 'value': 'adjustment', 'label': '調整' }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.listLoading = true
      console.log(this.listQuery)
      const { data } = await eventResource.getSelfCreateRecords(this.listQuery)
      console.log(data)
      this.list = data.items
      this.total = data.total
      this.userSelf = data.userSelf
      this.listLoading = false
    },
    handleFilter() {
      this.getList()
    }
  }
}
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.el-table {
  position: inherit!important;
}
</style>
